<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.addonStart) {
    <span
      class="input-group-text"
      [ngClass]="props.addonStartClass"
      >
      {{ props.addonStart }}
    </span>
  }

  <input
    type="number"
    class="form-control"
    [formControl]="$any(formControl)"
    [placeholder]="props.placeholder"
    [formlyAttributes]="field"
    [attr.data-testid]="props.testId"
    (keydown)="preventUnwanted($event)"
    />

  @if (props.addonEnd) {
    <span
      class="input-group-text"
      [ngClass]="props.addonEndClass"
      >
      {{ props.addonEnd }}
    </span>
  }
</div>
@if (showError && props.groupedField) {
  <div
    class="d-flex gap-3 align-items-center mt-2 alert alert-danger "
    >
    <i class="fas fa-times-circle"></i>
    <span>
      <formly-validation-message [field]="field" />
    </span>
  </div>
}
